export const SET_WALLET_DATA = "SET_WALLET_DATA";
export const SET_ALL = "SET_ALL";
export const SET_RECEIVEDS = "SET_RECEIVEDS";
export const RECEIVEDS_TOTAL = "RECEIVEDS_TOTAL";
export const SET_SENDEDS = "SET_SENDEDS";
export const SENDEDS_TOTAL = "SENDEDS_TOTAL";
export const REMOVE_TICKET_DATA = "REMOVE_TICKET_DATA";
export const PAGE = "PAGE";
export const LIMIT = "LIMIT";
export const TOTAL_RESOURCES = "TOTAL_RESOURCES";
export const LIMIT_OPTIONS = "LIMIT_OPTIONS";
export const LOADING_DATA = "LOADING_DATA";
export const WITHDRAW = "WITHDRAW";
export const WITHDRAW_SUCCESS = "WITHDRAW_SUCCESS";
export const WITHDRAW_ERROR = "WITHDRAW_ERROR";
export const WITHDRAW_ERROR_MESSAGE = "WITHDRAW_ERROR_MESSAGE";
export const NOTIFICATION_BAR = "NOTIFICATION_BAR";
export const SHOW_FILTERS = "SHOW_FILTERS";
export const FILTER_PARAMS = "FILTER_PARAMS";
export const ORDINATION = "ORDINATION";

export const SET_FILTER_ID = "SET_FILTER_ID";
export const KIND = "KIND";
export const SET_FILTER_POSITIVE = "SET_FILTER_POSITIVE";
export const SET_FILTER_TYPE_ID = "SET_FILTER_TYPE_ID";
export const SET_FILTER_KIND = "SET_FILTER_KIND";
export const SET_FILTER_TYPE_AMOUNT = "SET_FILTER_TYPE_AMOUNT";
export const SET_FILTER_INITIAL_DATE = "SET_FILTER_INITIAL_DATE";
export const SET_FILTER_FINAL_DATE = "SET_FILTER_FINAL_DATE";
export const FILTER_INITIAL_DATE = "FILTER_INITIAL_DATE";
export const FILTER_FINAL_DATE = "FILTER_FINAL_DATE";
export const FILTER_ORDER = "FILTER_ORDER";

export const SET_FILTER_ORDINATION = "SET_FILTER_ORDINATION";
